import React from "react";
import {
  AppBar,
  Box,
  Grid,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { AuthContext } from "../services/Context/Auth/context";
import { useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const Navbar = ({ handleMenu }) => {
  const navigate = useNavigate();

  const { handleLogout } = useContext(AuthContext);
  return (
    <Box>
      <AppBar sx={{ bgcolor: "#fafafa" }} position="static">
        <Toolbar>
          <Grid container alignItems="center">
            <Grid xs={2} item>
              <Typography
                variant="h4"
                component="div"
                color="text.primary"
                sx={{ my: "0" }}
              >
                Coated Lens
              </Typography>
            </Grid>
            <Grid xs={5} item>
              <IconButton onClick={handleMenu}>
                <MenuIcon bgcolor="text.primary" sx={{ fontSize: "40px" }} />
              </IconButton>
            </Grid>
            <Grid
              xs={5}
              container
              direction="row"
              justifyContent="flex-end"
              item
            >
              <Button
                variant="contained"
                sx={{ bgcolor: "#ff258d" }}
                disableElevation
                onClick={() => {
                  handleLogout();
                  navigate("/");
                }}
              >
                Logout
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
};
Navbar.propTypes = {
  handleMenu: PropTypes.func.isRequired,
};
export default Navbar;
